import { defineSetting } from './settingsRegistry';

declare module './settingsRegistry' {
  interface Settings {
    /** Ground moves cast at the mouse on the key press, no confirming click (input.ts useSlot; docs/design/ui/2026-10-11-ground-aim). */
    quickCastGround: boolean;
  }
}

defineSetting({
  key: 'quickCastGround',
  default: false,
  order: 352,
  menu: { group: 'visual', label: 'ท่าเลือกพื้นที่: ปล่อยที่เมาส์ทันที (ไม่ต้องคลิกยืนยัน)' },
});
